/**
 * ProgramSwitcherPage.js — wraps ProgramSwitcher for the
 *   /program/switch route.
 *
 * Pulls the user's licensed-program list from the backend.
 * Falls back to ["practice"] for any non-licensed visitor so the
 * page never breaks. The "summative" card shows the locked
 * "Request Upgrade" state when not licensed — exactly the design.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import ProgramSwitcher from "../components/program/ProgramSwitcher";
import { useAuth } from "../contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProgramSwitcherPage() {
  const { user } = useAuth();
  const [licensed, setLicensed] = useState(["practice"]);

  useEffect(() => {
    let cancelled = false;
    // AuthContext attaches the Bearer token via a global axios interceptor,
    // so no manual header config is required here.
    axios
      .get(`${API}/me/licensed-programs`)
      .then((res) => {
        if (cancelled) return;
        const arr = res?.data?.programs;
        if (Array.isArray(arr) && arr.length) setLicensed(arr);
      })
      .catch(() => {
        // Endpoint may not exist yet (Sprint 1 wiring). Treat super
        // admins as licensed for both products so the operator can
        // exercise the full surface without a backend round-trip.
        if (user?.role === "super_admin") setLicensed(["practice", "summative"]);
      });
    return () => {
      cancelled = true;
    };
  }, [user]);

  return <ProgramSwitcher availablePrograms={licensed} redirectPath="/" />;
}
